<p>operation-prescripteurs-details works!</p>
